import { Navigate, Routes, Route } from "react-router-dom";

import PageHeader from "components/PageHeader";
import { usePermission } from "utils/usePermission";
import ManageRules from "./ManageRules";
import ContactBlacklist from "./ContactBlacklist";

import styles from "./RfqNotifications.module.scss";

const RfqNotifications = () => {
  const canManageRules = usePermission("rfq_notification.manage_rfq_notifications");
  const canManageBlacklist = usePermission("rfq_notification.manage_rfq_contact_blacklist");

  if (!canManageRules && !canManageBlacklist) {
    return <Navigate to="/" />;
  }

  return (
    <div className={styles.wrapper}>
      <PageHeader title="RFQ Notifications" />

      <div className={styles.content}>
        <Routes>
          {canManageRules && (
            <Route path="/manage-rules/*" element={<ManageRules />} />
          )}
          {(canManageRules || canManageBlacklist) && (
            <Route path="/contact-blacklist" element={<ContactBlacklist />} />
          )}
          {/* Default route */}
          <Route path="/" element={
            canManageRules ?
              <Navigate to="/rfq-notifications/manage-rules" replace /> :
              <Navigate to="/rfq-notifications/contact-blacklist" replace />
          } />
        </Routes>
      </div>
    </div>
  );
};

export default RfqNotifications;
